// Import HTTP client
import {
  initiateTransferService,
  resolveAccountService,
  initiateAssetTransferService,
  getBeneficiaryService,
  saveBeneficiaryService,
  deleteBeneficiaryService,
  uploadTransferDocumentService,
  getSupportedBanksService,
  getDateRateServices,
  submitQuestionnaireService,
  processTransferService,
  getSupportedCountriesService,
  validatePhoneNumberService
} from '@/services/terminalService'
// mutations types
const set_terminalTransferType = 'set_terminalTransferType'
const set_partnerCommission = 'set_partnerCommission'
const set_partnerCommissionType = 'set_partnerCommissionType'
const set_recipientInformation = 'set_recipientInformation'
const set_transferDetails = 'set_transferDetails'
const set_transferInfo = 'set_transferInfo'
const set_resolveAccountName = 'set_resolveAccountName'
const set_validatePhoneNumber = 'set_validatePhoneNumber'
const set_failedDepositAssetReason = 'set_failedDepositAssetReason'
const set_hasBeenDebited = 'set_hasBeenDebited'
const set_assetDepositId = 'set_assetDepositId'
const set_beneficiaries = 'set_beneficiaries'
const set_currentBeneficiary = 'set_currentBeneficiary'
const set_usedBeneficiary = 'set_usedBeneficiary'
const set_beneficiaryID = 'set_beneficiaryID'
const set_beneficiaryOption = 'set_beneficiaryOption'
const set_depositWalletView = 'set_depositWalletView'
const set_assetTransferState = 'set_assetTransferState'
const set_uploadedDocument = 'set_uploadedDocument'
const set_supportedBanks = 'set_supportedBanks'
const set_depositMethod = 'set_depositMethod'
const set_dateRate = 'set_dateRate'
const set_submitQuestionnaire = 'set_submitQuestionnaire'
const set_currentTransferDetails = 'set_currentTransferDetails'
const set_initiateTransferMethod = 'set_initiateTransferMethod'
const set_supportedCountries = 'set_supportedCountries'
// state
const getDefaultState = () => {
  return {
    hasBeenDebited: false,
    transferTerminalDetails: {
      recipientInformation: {},
      transferDetails: {}
    },
    currentTransferDetails: {},
    initiateTransferMethod: '',
    depositMethod: '',
    assetDepositId: '',
    terminalTransferType: null,
    usedBeneficiary: false,
    beneficiaryOption: true,
    partnerCommissionType: 'Fixed',
    beneficiaryID: '',
    transferInfo: {},
    resolveAccountName: '',
    validatePhoneNumber: false,
    failedDepositAssetReason: '',
    beneficiaries: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    currentBeneficiary: {},
    depositWalletView: 'wallet-address',
    assetTransferState: '',
    supportedBanks: [],
    supportedCountries: [],
    dateRate: '',
    submitQuestionnaire: false
  }
}
const state = getDefaultState()

// getters
const getters = {
  getTerminalTransferType: (state) => state.terminalTransferType,
  getPartnerCommission: (state) => state.partnerCommission,
  getResolveAccountName: (state) => state.resolveAccountName,
  getBeneficiaries: (state) => state.beneficiaries
}
// mutations
const mutations = {
  [set_terminalTransferType] (state, payload) {
    state.terminalTransferType = payload
  },
  [set_initiateTransferMethod] (state, payload) {
    state.initiateTransferMethod = payload
  },
  [set_currentTransferDetails] (state, payload) {
    state.currentTransferDetails = payload
  },
  [set_recipientInformation] (state, payload) {
    state.transferTerminalDetails.recipientInformation = payload
  },
  [set_transferDetails] (state, payload) {
    state.transferTerminalDetails.transferDetails = payload
  },
  [set_partnerCommission] (state, payload) {
    state.partnerCommission = payload
  },
  [set_partnerCommissionType] (state, payload) {
    state.partnerCommissionType = payload
  },
  [set_transferInfo] (state, payload) {
    state.transferInfo = payload
  },
  [set_resolveAccountName] (state, payload) {
    state.resolveAccountName = payload
  },
  [set_validatePhoneNumber] (state, payload) {
    state.validatePhoneNumber = payload
  },
  [set_failedDepositAssetReason] (state, payload) {
    state.failedDepositAssetReason = payload
  },
  [set_assetDepositId] (state, payload) {
    state.assetDepositId = payload
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  [set_hasBeenDebited] (state, payload) {
    state.hasBeenDebited = payload
  },
  [set_beneficiaries] (state, data) {
    state.beneficiaries = data
  },
  [set_currentBeneficiary] (state, data) {
    state.currentBeneficiary = data
  },
  [set_usedBeneficiary] (state, data) {
    state.usedBeneficiary = data
  },
  [set_beneficiaryOption] (state, data) {
    state.beneficiaryOption = data
  },
  [set_beneficiaryID] (state, data) {
    state.beneficiaryID = data
  },
  [set_depositWalletView] (state, data) {
    state.depositWalletView = data
  },
  [set_assetTransferState] (state, data) {
    state.assetTransferState = data
  },
  [set_uploadedDocument] (state, data) {
    state.uploadedDocument = data
  },
  [set_supportedBanks] (state, payload) {
    state.supportedBanks = payload
  },
  [set_depositMethod] (state, payload) {
    state.depositMethod = payload
  },
  [set_dateRate] (state, data) {
    state.dateRate = data
  },
  [set_submitQuestionnaire] (state, data) {
    state.submitQuestionnaire = data
  },
  [set_supportedCountries] (state, payload) {
    state.supportedCountries = payload
  }
}
// actions
const actions = {
  resetTerminalState ({ commit }) {
    commit('resetState')
  },
  setTerminalTransferType: ({ commit }, payload) => {
    commit('set_terminalTransferType', payload)
  },
  setInitiateTransferMethod: ({ commit }, payload) => {
    commit('set_initiateTransferMethod', payload)
  },
  setCurrentTransferDetails: ({ commit }, payload) => {
    commit('set_currentTransferDetails', payload)
  },
  setDepositMethod: ({ commit }, payload) => {
    commit('set_depositMethod', payload)
  },
  hasBeenDebited: ({ commit }, payload) => {
    commit('set_hasBeenDebited', payload)
  },
  partnerCommission: ({ commit }, payload) => {
    commit('set_partnerCommission', payload)
  },
  partnerCommissionType: ({ commit }, payload) => {
    commit('set_partnerCommissionType', payload)
  },
  setRecipientInformation: ({ commit }, payload) => {
    commit('set_recipientInformation', payload)
  },
  setTransferDetails: ({ commit }, payload) => {
    commit('set_transferDetails', payload)
  },

  initiateTransfer: ({ commit }, payload) => {
    return initiateTransferService(payload).then((response) => {
      commit('set_transferInfo', response.data.data)
    })
  },
  initiateAssetTransfer: ({ commit }, payload) => {
    return initiateAssetTransferService(payload).then((response) => {
      commit('set_transferInfo', response.data.data)
    })
  },
  setResolveAccountName: ({ commit }, payload) => {
    return resolveAccountService(payload).then((response) => {
      commit('set_resolveAccountName', response.data.data.accountName)
    })
  },
  setValidatePhoneNumber: ({ commit }, payload) => {
    return validatePhoneNumberService(payload).then((response) => {
      commit('set_validatePhoneNumber', response.data.data)
    })
  },
  setFailedDepositAssetReason: ({ commit }, payload) => {
    commit('set_failedDepositAssetReason', payload)
  },
  setAssetDepositId: ({ commit }, payload) => {
    commit('set_assetDepositId', payload)
  },
  usedBeneficiary: ({ commit }, data) => {
    commit('set_usedBeneficiary', data)
  },
  beneficiaryID: ({ commit }, data) => {
    commit('set_beneficiaryID', data)
  },
  beneficiaryOption: ({ commit }, data) => {
    commit('set_beneficiaryOption', data)
  },
  getBeneficiaries: ({ commit }, payload) => {
    return getBeneficiaryService(payload).then((response) => {
      commit('set_beneficiaries', response.data.data)
    })
  },
  saveBeneficiary: ({ commit }, payload) => {
    return saveBeneficiaryService(payload).then((response) => {
      commit('set_currentBeneficiary', response.data.data)
    })
  },
  deleteBeneficiary: ({ commit }, id) => {
    return deleteBeneficiaryService(id).then((res) => {})
  },
  setDepositWalletView: ({ commit }, payload) => {
    commit('set_depositWalletView', payload)
  },
  setAssetTransferState: ({ commit }, payload) => {
    commit('set_assetTransferState', payload)
  },
  uploadTransferDocument: ({ commit }, payload) => {
    return uploadTransferDocumentService(payload).then((response) => {
      commit('set_uploadedDocument', response.data.data)
    })
  },
  submitQuestionnaire: ({ commit }, payload) => {
    return submitQuestionnaireService(payload).then((response) => {
      commit('set_submitQuestionnaire', response.data.data)
    })
  },
  getSupportedBanks: ({ commit }, payload) => {
    return getSupportedBanksService(payload).then((response) => {
      commit('set_supportedBanks', response.data.data)
    })
  },
  getSupportedCountries: ({ commit }) => {
    return getSupportedCountriesService().then((response) => {
      commit('set_supportedCountries', response.data.data)
    })
  },
  getDateRate: ({ commit }, payload) => {
    return getDateRateServices(payload).then((response) => {
      commit('set_dateRate', response.data.data)
    })
  },
  processTransfer: ({ commit }, payload) => {
    return processTransferService(payload).then((res) => {})
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
